import React, { useState } from "react";
import stylesPc from "../../viewer/UploadSlideStock.module.css";
import stylesSp from "../../viewer/UploadSlideStock_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import { Box, createStyles, makeStyles, Tab, Tabs } from "@material-ui/core";
import { Chapter, Tip } from "../../../models/slides";
import SlideViewContent from "./SlideViewContent";
import "react-tabs/style/react-tabs.css";
import IndexDetailInfo from "./IndexDetailInfo";
import TipDetailInfo from "./TipDetailInfo";

// タブ値設定
const INDEX: number = 0;
const TIPS: number = 1;

interface DetailInfoProps {
    setIsSaved: (isSaved: boolean) => void;
    chapterLists: Chapter[];
    setChapterList: (chapterLists: Chapter[]) => void;
    tipLists: Tip[];
    setTipList: (tipLists: Tip[]) => void;
    editFlg: boolean;
    isEditModal?: boolean;
}

export function DetailInfo({
    setIsSaved,
    chapterLists,
    setChapterList,
    tipLists,
    setTipList,
    editFlg,
    isEditModal,
}: DetailInfoProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    // 選択されたタブのテキスト色
    const useStyles = makeStyles(() =>
        createStyles({
            tabTextColor: {
                color: isEditModal ? "white" : "var(--black)",
            },
        })
    );

    const classes = useStyles();
    // ページ番号
    const [pageNumber, setPageNumber] = useState(1);

    // Tabを選択時に画面を切り替える変数定義
    const [tabValue, setTabValue] = useState<typeof INDEX | typeof TIPS>(INDEX);
    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setTabValue(newValue);
    };

    // TabPanel用
    const TabPanel = (props: { children?: React.ReactNode; value: any; index: any }) => {
        const { children, value, index, ...other } = props;
        return (
            <div role="tabpanel" hidden={value !== index} {...other}>
                {value === index && <Box p={3}>{children}</Box>}
            </div>
        );
    };

    return (
        <>
            <div className={styles.previewFileDiv}>
                <SlideViewContent
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    editFlg={editFlg}
                />
            </div>
            {/* 詳細情報入力タブ */}
            <div className={styles.mainInfoDiv}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    className={classes.tabTextColor}
                    TabIndicatorProps={{
                        style: {
                            background: isEditModal ? "var(--studio-btn-bg)" : "var(--main)",
                        },
                    }}
                >
                    <Tab label="Index" />
                    <Tab label="Tips" />
                </Tabs>
                {isEditModal ? (
                    <>
                        <TabPanel index={INDEX} value={tabValue}>
                            <div className={styles.chapterInfoDiv}>
                                <IndexDetailInfo
                                    setIsSaved={setIsSaved}
                                    pageNumber={pageNumber}
                                    chapterLists={chapterLists}
                                    setChapterList={setChapterList}
                                    isEditModal={true}
                                />
                            </div>
                        </TabPanel>
                        <TabPanel index={TIPS} value={tabValue}>
                            <div className={styles.tipInfoDiv}>
                                <TipDetailInfo
                                    setIsSaved={setIsSaved}
                                    pageNumber={pageNumber}
                                    tipLists={tipLists}
                                    setTipList={setTipList}
                                    isEditModal={true}
                                />
                            </div>
                        </TabPanel>
                    </>
                ) : (
                    <>
                        <TabPanel index={INDEX} value={tabValue}>
                            <div className={styles.chapterInfoDiv}>
                                <IndexDetailInfo
                                    setIsSaved={setIsSaved}
                                    pageNumber={pageNumber}
                                    chapterLists={chapterLists}
                                    setChapterList={setChapterList}
                                />
                            </div>
                        </TabPanel>
                        <TabPanel index={TIPS} value={tabValue}>
                            <div className={styles.tipInfoDiv}>
                                <TipDetailInfo
                                    setIsSaved={setIsSaved}
                                    pageNumber={pageNumber}
                                    tipLists={tipLists}
                                    setTipList={setTipList}
                                />
                            </div>
                        </TabPanel>
                    </>
                )}
            </div>
        </>
    );
}
